module.exports = __webpack_public_path__ + "static/media/3.334b9626.jpg";